import { render, staticRenderFns } from "./addOrEditClass.vue?vue&type=template&id=d29619ca&scoped=true&"
import script from "./addOrEditClass.vue?vue&type=script&lang=js&"
export * from "./addOrEditClass.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditClass.vue?vue&type=style&index=0&id=d29619ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29619ca",
  null
  
)

export default component.exports